import { IntegrationType } from "~/operations";
import { ticketingIntegrationTypes } from "~/pages/integrations/utils/integrationConstants";

// format system name based on issue type
export const ticketingSystemName = (
  ticketType: (typeof ticketingIntegrationTypes)[number],
): string => {
  switch (ticketType) {
    case IntegrationType.TicketSystemJira:
      return "Jira";
    case IntegrationType.TicketSystemGithub:
      return "GitHub";
    case IntegrationType.TicketSystemGitlab:
      return "GitLab";
    case IntegrationType.TicketSystemZendesk:
      return "Zendesk";
    case IntegrationType.TicketSystemAzureDevops:
      return "Azure DevOps";
    case IntegrationType.TicketSystemEmail:
      return "Email";
    default:
      return "";
  }
};
